import React from 'react';
import { Link } from 'umi';

export const languageMapDocumentUrl =
  'https://doc.weixin.qq.com/sheet/e3_ABQAXwZ2ACcXu4HdGzuRLma2DrNja?scode=AJEAIQdfAAoYo81mdkABQAXwZ2ACc&tab=BB08J2';
export const documentEh = (
  <a target="_blank" href={languageMapDocumentUrl}>
    Click to see the National Language Mapping rule &gt;
  </a>
);
export const documentCh = (
  <a target="_blank" href={languageMapDocumentUrl}>
    点击查看国家语种映射对照表 &gt;
  </a>
);

const sentimentUrl = '/opinion/DataMap/SentimentCriteria';
export const sentimentEn = (
  <Link to={sentimentUrl}>Click to see the Sentiment Criteria &gt;</Link>
);

export const sentimentCh: any = (
  <Link to={sentimentUrl}>点击查看 情感分标准 &gt;</Link>
);

const GPTSummaryDemoUrl = '/opinion/DataMap/AISummaryDemo';
export const GPTSummaryDemoUrlEn = (
  <Link to={GPTSummaryDemoUrl}>Click to see the AI Summary Demo &gt;</Link>
);

export const GPTSummaryDemoUrlCh: any = (
  <Link to={GPTSummaryDemoUrl}>点击查看两种总结的效果示例 &gt;</Link>
);

const brandHealthUrl = (text = 'Brand Health') =>
  `/opinion/DataMap/OpinionsMetrics?keyword=${text}`;
export const brandHealthCh: any = (
  <Link to={brandHealthUrl('品牌健康度')}>查看更多指标说明 &gt;</Link>
);

export const brandHealthEn: any = (
  <Link to={brandHealthUrl()}>View more details &gt;</Link>
);

const validationUrl = '/opinion/DataMap/ValidationCriteria';
export const validationEn = (
  <Link to={validationUrl}>Click to see the Validation Criteria &gt;</Link>
);
export const validationCh = (
  <Link to={validationUrl}>点击查看 有效性标准 &gt;</Link>
);
